import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { Box, ControlGroup, TextAreaField } = designSystem;
const defaultRules = {};

const TextField = ({
  name,
  placeholder,
  title = '',
  description = '',
  isSubField = false,
  control,
  rules = defaultRules,
}) => {
  const classes = classNames('ws-difm-banner-textarea', {
    'ws-difm-banner-textarea--sub-field': isSubField,
  });

  return (
    <ControlGroup required title={title} description={description}>
      <Box {...(isSubField && { paddingLeft: 'spacing-l' })}>
        <div className={classes}>
          <TextAreaField control={control} rules={rules} name={name} placeholder={placeholder} />
        </div>
      </Box>
    </ControlGroup>
  );
};

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  isSubField: PropTypes.bool,
  control: PropTypes.shape({}).isRequired,
  rules: PropTypes.shape({}),
};

export default TextField;
